import {authHeader} from "../util/auth-header";
import http from "../util/http-common";

export class BaseService {

  static async get(endpoint: string) {
    return http.get(endpoint , { headers: await authHeader() });
  }

  static async post(endpoint: string, data: any) {
    return http.post(endpoint, data, { headers: await authHeader() });
  }

  static async put(endpoint: string, id: any, data: any) {
    return http.put(`${endpoint}/${id}`, data, { headers: await authHeader() });
  }

  static async delete(endpoint: string, id: any) {
    return http.delete(`${endpoint}/${id}`, { headers: await authHeader() });
  }
}

export default BaseService;